import './styles.css';
import OptionalInput from '../OptionalInput';
import Counter from '../Counter';
import Note from '../Note';
import Modal from '../Modal';
import { useModalState } from 'hooks';
import { useTranslation } from 'react-i18next';

import type { Bend } from 'components/MultiStepForm/types';

interface AttachmentCardProps extends Bend {
  quantity: number;
  coverQuantity: number;
  hasCouplers: boolean;
  setBendCount: (
    bendOrCover: 'bend' | 'cover',
    id: string,
    name: string,
    type: string,
    count: number
  ) => void;
}

const ExtendedCouplerImageMapping: Record<string, string> = {
'T stuk-Kleine radius':'https://wibe-group.com/storage/AE6BDABD95FCD1B065C5A200806B6DDEE435EA469A0A83A590AE8A372CF288F7/08aceb5040d34e5abb41f4c75f7f5edc/500-250-0-png.Png/media/e99d4dda865d4cec8e1f437de6cf4830/T%20stuk%20recht.png',
'T stuk-Grote radius':'https://wibe-group.com/storage/7562A322A8F98DCE6035DA68944C56CEBFFC3D1F489368CFE88E2EA98BC79FEE/a22e326cebb149a684f2e8dcf8dbed24/500-250-0-png.Png/media/e4752c1ca16042be97f22cf50f6319ce/T%20stuk%20hoek.png',
'Hoekstuk-Medium radius':'https://wibe-group.com/storage/51CA3DEBB8FFA4E0D2CFAD97F5D54AEF1BB5008AF6B00C288DD50051D8B556E4/4396ff1075974e93bdf1bb4717a33954/500-250-0-png.Png/media/2a4486c32f4947e99d898bed45e92c0b/Hoek%20rond.png',
'Hoekstuk-Kleine radius':'https://wibe-group.com/storage/D699A782EED1BB78961951FC8FC449705BC167FDCA137C37C0581F5D0F2060F2/97e2fe2cabd94494a5b1f94e49a24496/500-250-0-png.Png/media/7b3c94736f494ec198a29d1ddd2e11cc/Hoek%20recht.png',
'Hoekstuk-Grote radius':'https://wibe-group.com/storage/75AE1FAB2488896493ECDDABB11E134DC75F063C4D27B9C6ECE0D95562D13857/c0fc9d8dc81f41dc92d9452bf18cedea/500-250-0-png.Png/media/c22e3841dbbb41d788f06dc44f077779/Hoek%20C1%20_%20C2%20_%20C3.png',
'Additioneel-Reduceerstuk':'https://wibe-group.com/storage/26CEA07F5651C79FCE437A3163EEC98F835CCC16C47D79663ACF48B1D533431F/3c3a44ca4392466b9467c6bf7bd85a64/png/media/90de70bcca2545eb8129e0277cfe7bad/Reduceerstuk.png',
'Additioneel-Vervalstijgstuk':'https://wibe-group.com/storage/86B37ED36A29E9F8C2D3A95995B02329683C061CE45A128162FC109C7569AA82/6e2f24e18192429b80b1d8b65ee0571a/png/media/21dab20cf162426f9ccee979e691bf8b/Vervalstijgstuk.png'
};

const InstallationImageMapping: Record<string, string> = {
'T stuk-Kleine radius':'https://wibe-group.com/storage/B66AEA1697A1CD414B721361E64CB499CCF957D9244FE936491E4F185C313425/5b46480d77fa4befb0925c7cc1fa59ad/PNG/media/093353e0aafb416ead2d73996bbe3b1f/T%20stuk%20-%20Kleine%20radius.PNG',
'T stuk-Grote radius':'https://wibe-group.com/storage/1866BFB6E7F6E98D731D1EDDD11200E2FE6BE9A91D9093A74323B1ADF4AF8D64/2f3d3be2879545ec896b30327c7f3cde/PNG/media/bf21193a8753420b8b96b7b9d5bbc45f/T%20stuk%20-%20Grote%20radius.PNG',
'Hoekstuk-Medium radius':'https://wibe-group.com/storage/A8C4EE2709289045277C9EBA9CA7D6070C4CFE44D27A7CB3F8E14F8FA1C1C78F/ea636b240a3c48f19e5c69820e49b7a9/PNG/media/cd6acaa66b1a41eaa1d07747f38b6c8c/Hoekstuk%20-%20Medium%20radius.PNG',
'Hoekstuk-Kleine radius':'https://wibe-group.com/storage/5A3FAEAD49D5F3AA3E4752578E1879A29AA2C52BF3766EC6C5A577C80BED57F7/dbbfd4e0e4e545019454bba29e473d5d/PNG/media/e3dc0b70025a4c41948e4db6f17ec8eb/Hoekstuk%20-%20Kleine%20radius.PNG',
'Hoekstuk-Grote radius':'https://wibe-group.com/storage/D104DCDC440F8028F7C3EF6B469EB7F8F8AD5DFDD2DBAEC1D9BC6C6740565940/3b8ca40d2ee6420382598adef98cbac4/PNG/media/2969f8c446a44f46afe50d2f5d4cc70b/Hoekstuk%20-%20Grote%20radius.PNG',
};

const AttachmentCard = ({
  cr,
  type,
  name,
  quantity,
  coverQuantity,
  imageUrl,
  setBendCount,
  hasCover,
  hasCouplers,
}: AttachmentCardProps) => {
  const { t } = useTranslation();
  const [isOpen, open, close] = useModalState(false);

  const setStartLidCount = (val: boolean) => {
    setBendCount('cover', cr, name, type, quantity);
  }

  const resetLidCount = () => {
    setBendCount('cover', cr, name, type, 0);
  }
  
  const imageKey = `${type}-${name}`;
 
  
  return (
    <>
      <div className="attachment-card">
        <strong>
          {type} - {name}
        </strong>
        <div>
          <div className="attachment-image center-x">
            <img src={imageUrl} alt="" />
            {ExtendedCouplerImageMapping[imageKey] && hasCouplers && (
              <>
                <img src={ExtendedCouplerImageMapping[imageKey]} alt="" />
                {InstallationImageMapping[imageKey] && (
                  <span onClick={open}>{t('backend.installation.guide')}</span>
                )}
              </>
            )}
          </div>
          <div className="attachment-quantity-counters">
            <Counter
              count={quantity}
              increment={() => setBendCount('bend', cr, name, type, quantity + 1)}
              decrement={() => setBendCount('bend', cr, name, type, quantity - 1)}
              onInputChange={(val) => setBendCount('bend', cr, name, type, val)}
            />
            {hasCover ? (
              <OptionalInput
                isInitiallyOpen={coverQuantity > 0}
                toggleText={
                  <span className="include-lid">
                    {t('selected.coupler.bend.item.include.lid')}
                  </span>
                }
                setStartLidCount={() => setStartLidCount(false)}
                resetLidCount={() => resetLidCount()}
              >
                <Counter
                  count={coverQuantity}
                  increment={() =>
                    setBendCount('cover', cr, name, type, coverQuantity + 1)
                  }
                  decrement={() =>
                    setBendCount('cover', cr, name, type, coverQuantity - 1)
                  }
                  onInputChange={(val) => setBendCount('cover', cr, name, type, val)}
                />
              </OptionalInput>
            ) : (
              <div style={{ width: 190 }}></div>
            )}
          </div>

          <div
            className="alert"
            style={{
              visibility: quantity < coverQuantity ? 'visible' : 'hidden',
            }}
          >
            <Note
              iconColor="#fcb900"
              text={t('validate.bend.quantities.msg')
                .replace(/#coverQuantity/g, quantity.toString())
                .replace(/#bendQuantity/g, coverQuantity.toString())}
            />
          </div>
        </div>
      </div>
      <Modal isOpen={isOpen} className="modal--viewport">
        <Modal.Header onClose={close}>{name}</Modal.Header>
        <Modal.Content>
          {InstallationImageMapping[imageKey] && hasCouplers && (
            <img
              src={InstallationImageMapping[imageKey]}
              alt={'coupler-img'}
            />
          )}
        </Modal.Content>
        <Modal.Footer style={{ flexDirection: 'row-reverse' }}>
          <button 
            className="btn-tertiary" 
            onClick={close}>{t('global.close')}</button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AttachmentCard;
